import { render, staticRenderFns } from "./Face.vue?vue&type=template&id=da8c7220&scoped=true&"
import script from "./Face.vue?vue&type=script&lang=js&"
export * from "./Face.vue?vue&type=script&lang=js&"
import style0 from "./Face.vue?vue&type=style&index=0&id=da8c7220&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8c7220",
  null
  
)

export default component.exports